export default {
	"AdditionalPageTypes": false,
	"Admin": true,
	"Advertising": true,
	"Advertising2": true,
	"AggregatedContentFeed": true,
	"AllowCustomFields": false,
	"AppConfig": true,
	"AppEcommerceManager": true,
	"AppScorePredictor": true,
	"AppSocialManager": true,
	"AppTicketingManager": true,
	"BreakingNews": false,
	"BuildManager": true,
	"Calendar": true,
	"CustomCommentary": true,
	"CustomLineups": true,
	"CustomTables": true,
	"CustomTags": true,
	"Dashboard": true,
	"Fixtures": true,
	"Forms": true,
	"HomepageManager": true,
	"HomepageNewsPromo": true,
	"HomepagePlayerHighlight": true,
	"Lab": true,
	"MapDirectory": true,
	"MatchdayTakeover": true,
	"Media": true,
	"News": true,
	"OptaIntegration": true,
	"Organisations": true,
	"OverlayPromos": true,
	"Pages": true,
	"PlatformOptions": true,
	"PlayerVoting": true,
	"PreventEntitlementEmails": false,
	"Profile": true,
	"RelatedContentTagging": true,
	"RewardsManager": true,
	"RewardPoints": true,
	"Rover": true,
	"Settings": false,
	"SiteConfig": true,
	"Sponsors": true,
	"Squads": true,
	"SsoUsers": true,
	"StreamAMGIntegration": true,
	"Streamline": true,
	"StreamlineAdverts": true,
	"StreamlinePromoCodes": true,
	"TeamCrestManager": true,
	"Videos": true,
	"Voice": true,
	"WebStats": true
}
